import { Module } from "vuex";
import { RootState } from "@/store/type";
import { CustomerState } from "@/store/customer/type";
import { getters } from "@/store/customer/getters";
import { actions } from "@/store/customer/actions";
import { mutations } from "@/store/customer/mutations";

const state: CustomerState = {
  me: null,
  isAuthenticated: false,
  cart: null,
};

export const customer: Module<CustomerState, RootState> = {
  state,
  getters,
  mutations,
  actions,

};




